import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { IconComponent } from '@softline/ui-core';
import { EventDetails } from '../../types/event';

const STATUS_LABELS: Record<string, string> = {
  busy: 'Beschäftigt',
  free: 'Frei',
  tentative: 'Mit Vorbehalt',
};

/** Read-only detail view for external calendar events (no edit actions). */
@Component({
  selector: 'soft-event-detail',
  templateUrl: './event-detail.component.html',
  imports: [DatePipe, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventDetailComponent {
  readonly details = input.required<EventDetails>();

  readonly sameDay = computed<boolean>(() => {
    const { start, end } = this.details();
    return start.toDateString() === end.toDateString();
  });

  readonly statusLabel = computed<string | null>(() => {
    const status = this.details().status;
    if (!status) return null;
    return STATUS_LABELS[status] ?? status;
  });
}
